import { type IIconsVector } from 'shared/ui'
import { type IPresetCardBadge } from 'shared/Preset'

export type ISurveyType = 'nps' | 'csat' | 'xsat' | 'ces' | 'pmf' | 'custom'

export type ISurveyTemplate = {
  type: ISurveyType
  icon: IIconsVector
  name: string
  description: string
  badge?: IPresetCardBadge
  disabled?: boolean
}

export const SurveyTemplates: ISurveyTemplate[] = [
  {
    type: 'nps',
    icon: 'usersCheck',
    name: 'NPS (Net Promoter Score)',
    description: 'Ask customers how likely they are to recommend you',
  },
  {
    type: 'csat',
    icon: 'emoji',
    name: 'CSAT (Customer Satisfaction)',
    description: 'See how satisfied customers are after a purchase or interaction',
    badge: 'comingSoon',
    disabled: true,
  },
  {
    type: 'xsat',
    icon: 'rocketSolid',
    name: 'XSAT (Experience Satisfaction)',
    description: 'Get feedback on a specific moment in the customer journey',
    badge: 'comingSoon',
    disabled: true,
  },
  {
    type: 'ces',
    icon: 'checkDone',
    name: 'CES (Customer Effort Score)',
    description: 'Find out how easy you are to do business with',
    badge: 'comingSoon',
    disabled: true,
  },
  {
    type: 'pmf',
    icon: 'target',
    name: 'PMF (Product-Market Fit)',
    description: 'See how customers would feel without your product',
    badge: 'comingSoon',
    disabled: true,
  },
  {
    type: 'custom',
    icon: 'settings',
    name: 'Custom',
    description: 'Build a survey from scratch',
    badge: 'comingSoon',
    disabled: true,
  },
]
